// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__gOQC_","modalFooterButton":"ModalNotes_modalFooterButton__1aORs"};